import { useFrame, useThree } from "@react-three/fiber";
import {
  useAwarenessUpdate,
  useBroadcastUpdate,
  useMultiuserContext,
  usePresentatorId,
  useSynchronizedState,
} from "@solidwhite/multiuser";
import { useEffect, useMemo, useRef } from "react";
import * as THREE from "three";
import { animated, useSpring } from "@react-spring/three";
import { CameraControls } from "@react-three/drei";

const targetVec = new THREE.Vector3();

const invisibleCamControl = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight);
const camTargetPosition = new THREE.Vector3();
const camNormal = new THREE.Vector3();

const RemoteCamera = ({ ...props }) => {
  const { camera } = useThree();
  const presentatorId = usePresentatorId();
  console.log("presentatorId", presentatorId);

  // useAwarenessUpdate(presentatorId, "cam", (e) => {
  //   if (!e) return;
  //   api.start(e);
  // });

  useBroadcastUpdate(presentatorId, "cam", (e) => {
    if (!e) return;
    api.start(e);
  });

  const cameraControlsRef = useRef();

  const tRef = useRef();
  const poRef = useRef();
  const yRef = useRef();
  const xRef = useRef();
  const dRef = useRef();
  const camRef = useRef();

  const [spring, api] = useSpring(() => ({
    t: [0, 0, 0],
    ct: [0, 0, 0],
    y: [0, 0, 0, 1],
    x: [0, 0, 0, 1],
    fov: 50,
    onChange: ({ value }) => {
      if (!tRef.current) return;

      cameraControlsRef.current.setLookAt(value.ct[0], value.ct[1], value.ct[2], value.t[0], value.t[1], value.t[2], false);

      camNormal.set(0, 0, 1).applyQuaternion(cameraControlsRef.current.camera.quaternion);
      camNormal.normalize().multiplyScalar(cameraControlsRef.current.distance);
      camTargetPosition.copy(cameraControlsRef.current.camera.position.clone().sub(camNormal));

      tRef.current.quaternion.copy(cameraControlsRef.current.camera.quaternion);
      dRef.current.position.set(0, 0, cameraControlsRef.current.distance);

      yRef.current.position.fromArray(value.t);
      yRef.current.quaternion.fromArray(value.y);
      xRef.current.quaternion.fromArray(value.x);

      const camFinalPos = new THREE.Vector3();
      camRef.current.getWorldPosition(camFinalPos);
      const camFinalQuat = new THREE.Quaternion();
      camRef.current.getWorldQuaternion(camFinalQuat);

      camera.position.copy(camFinalPos);
      camera.quaternion.copy(camFinalQuat);
      camera.fov = value.fov;
      camera.updateProjectionMatrix();
    },
  }));

  // useEffect(() => {
  //   api.start(cameraState);
  // }, [cameraState]);

  useFrame(() => {
    // if (!tRef.current) return;
    // yRef.current.position.fromArray(cameraState.t);
    // tRef.current.quaternion.fromArray(cameraState.tq);
    // yRef.current.quaternion.fromArray(cameraState.y);
    // xRef.current.quaternion.fromArray(cameraState.x);
    // dRef.current.position.setZ(cameraState.d);
    // const camFinalPos = new THREE.Vector3();
    // camRef.current.getWorldPosition(camFinalPos);
    // const camFinalQuat = new THREE.Quaternion();
    // camRef.current.getWorldQuaternion(camFinalQuat);
    // camera.position.copy(camFinalPos);
    // camera.quaternion.copy(camFinalQuat);
    // camera.fov = cameraState.fov;
    // camera.updateProjectionMatrix();
    // console.log(cameraControlsRef.current.azimuthAngle);
  }, []);

  return (
    <>
      <group ref={yRef}>
        <group ref={tRef}>
          <group ref={poRef}>
            <group ref={xRef}>
              <group ref={dRef}>
                <group ref={camRef}></group>
                {/* <mesh>
              <sphereGeometry />
              <meshBasicMaterial color="red" transparent depthTest={false} />
            </mesh> */}
              </group>
            </group>
          </group>
        </group>
      </group>

      <CameraControls
        ref={cameraControlsRef}
        smoothTime={0.35}
        camera={invisibleCamControl}
        makeDefault={false}
        verticalDragToForward={false}
        enabled={true}
        // minAzimuthAngle={THREE.MathUtils.degToRad(360-90)}
        // maxAzimuthAngle={THREE.MathUtils.degToRad(360+90)}
      />
    </>
  );
};

export default RemoteCamera;
